import React, { useState, useEffect, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { API_URL, IMAGE_BASE_URL } from "../../constant";
import "./CaptainTCCard.css";
import fivePoundCardImg from "../../images/captain-tc/5PoundCard.jpg";
import promoTopCoinIcon from "../../images/shapes/tc-units-wallet 2.png";
import promoCashIcon from "../../images/shapes/tc-cash-wallet 1.png";
import oldbank from "../../images/shapes/bank-pound-icon2 4.png";

function CaptainTCCardAgent() {
  const outletContext = useOutletContext() || {};
  const { userData } = outletContext;

  const [loading, setLoading] = useState(true);
  const [cards, setCards] = useState([]);
  const [seniorWallet, setSeniorWallet] = useState(null);
  const [miniWallet, setMiniWallet] = useState(null);
  const [miniWalletPage, setMiniWalletPage] = useState(1);
  const miniWalletItemsPerPage = 5;

  // Promo wallet balances
  const [extraCardBalance, setExtraCardBalance] = useState(0);
  const [bonusCardBalance, setBonusCardBalance] = useState(0);
  const [unclaimedMilestones, setUnclaimedMilestones] = useState(0);
  const [hasPendingRequest, setHasPendingRequest] = useState(false);
  const [claimLoading, setClaimLoading] = useState(false);

  // History state
  const [historyLoading, setHistoryLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [historyPage, setHistoryPage] = useState(1);
  const [historyTotalPages, setHistoryTotalPages] = useState(1);
  const [showFullHistory, setShowFullHistory] = useState(false);
  const [selectedSbcRef, setSelectedSbcRef] = useState(null);

  const getAuthHeaders = useCallback(() => {
    const token = localStorage.getItem("auth_token");
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  }, []);

  const fetchCardStatus = useCallback(async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("auth_token");
      if (!token) return;

      const response = await fetch(`${API_URL}/api/customer/captain-tc-cards`, {
        headers: getAuthHeaders(),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success && data.cards) {
          setCards(data.cards || []);
        }
        // Set promo wallet balances
        if (data.promo_wallet) {
          setExtraCardBalance(data.promo_wallet.extra_card_balance || 0);
          setBonusCardBalance(
            ((data.promo_wallet.total_extra_card_balance * 5) /
              data.promo_wallet.total_extra_card_balance) *
              data.promo_wallet.extra_card_balance || 0,
          );
          setUnclaimedMilestones(data.promo_wallet.unclaimed_milestones || 0);
          setHasPendingRequest(data.promo_wallet.has_pending_request || false);
        }

        if (data.senior_wallet) {
          setSeniorWallet(data.senior_wallet);
        }

        if (data.mini_wallet) {
          setMiniWallet(data.mini_wallet);
        }
      }
    } catch (err) {
      console.warn("Captain TC Cards API not available:", err.message);
    } finally {
      setLoading(false);
    }
  }, [getAuthHeaders]);

  const handleClaimCashback = async () => {
    if (hasPendingRequest || unclaimedMilestones <= 0) return;

    try {
      setClaimLoading(true);
      const token = localStorage.getItem("auth_token");
      const response = await fetch(
        `${API_URL}/api/customer/captain-tc-cards/claim-cashback`,
        {
          method: "POST",
          headers: getAuthHeaders(),
        },
      );

      const data = await response.json();
      if (response.ok && data.success) {
        alert(data.message || "Cash back claim submitted successfully.");
        setHasPendingRequest(true);
        // Reduce unclaimed visually immediately to avoid double clicks
        setUnclaimedMilestones(0);
      } else {
        alert(data.message || "Failed to submit claim.");
      }
    } catch (err) {
      console.error("Error claiming cash back:", err);
      alert("An error occurred during submission.");
    } finally {
      setClaimLoading(false);
    }
  };

  const fetchHistory = useCallback(
    async (page = 1, limit = 5) => {
      try {
        setHistoryLoading(true);
        const token = localStorage.getItem("auth_token");
        if (!token) return;

        const response = await fetch(
          `${API_URL}/api/customer/captain-tc-cards/history?page=${page}&per_page=${limit}`,
          {
            headers: getAuthHeaders(),
          },
        );

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.history) {
            setHistory(data.history.data || []);
            setHistoryPage(data.history.current_page || 1);
            setHistoryTotalPages(data.history.last_page || 1);
          }
        }
      } catch (err) {
        console.warn("Captain TC Cards history API error:", err.message);
      } finally {
        setHistoryLoading(false);
      }
    },
    [getAuthHeaders],
  );

  const toggleHistoryView = () => {
    const newShowFull = !showFullHistory;
    setShowFullHistory(newShowFull);
    fetchHistory(1, newShowFull ? 10 : 5);
  };

  const handleCopySbcRef = async (ref) => {
    try {
      await navigator.clipboard.writeText(ref);
      alert("SBC REF copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  useEffect(() => {
    fetchCardStatus();
    fetchHistory(1, 5);
  }, [fetchCardStatus, fetchHistory]);

  if (loading) {
    return (
      <div className="captain-tc-wrapper">
        <div className="captain-tc-loading">
          <div className="captain-tc-spinner"></div>
          {/* <p style={{ marginTop: "15px", color: "#666", fontWeight: "500" }}>Loading...</p> */}
        </div>
      </div>
    );
  }

  return (
    <div className="captain-tc-wrapper">

      {seniorWallet && (
        <div
          className="senior-rewards-wallet-container"
          style={{
            marginBottom: "30px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "20px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <h2
            style={{ textAlign: "center", marginBottom: "10px", color: "#333" }}
          >
            Captain TC Senior Agent Rewards Wallet
          </h2>
          <h3
            style={{
              textAlign: "center",
              fontWeight: "normal",
              color: "#555",
              marginBottom: "20px",
            }}
          >
            ({seniorWallet.legendary_name})
          </h3>

          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: "4px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                backgroundColor: "#222",
                color: "#fff",
                padding: "12px",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              Name and Card Number
            </div>
            <div style={{ overflowX: "auto" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(10, 1fr)",
                  minWidth: "800px",
                }}
              >
                {seniorWallet.minicampaigns &&
                  seniorWallet.minicampaigns.map((mc, index) => (
                    <div
                      key={mc.id}
                      style={{
                        borderRight:
                          (index + 1) % 10 !== 0 ? "1px solid #ddd" : "none",
                        borderBottom: index < 40 ? "1px solid #ddd" : "none",
                        padding: "15px 5px",
                        textAlign: "center",
                        fontSize: "13px",
                        backgroundColor: mc.is_assigned
                          ? "lightgreen"
                          : "#f5f5f5",
                        color: "#333",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        wordBreak: "break-word",
                      }}
                    >
                      {mc.name}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {miniWallet && (
        <div
          className="mini-rewards-wallet-container"
          style={{
            marginBottom: "30px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "20px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <h2
            style={{ textAlign: "center", marginBottom: "10px", color: "#333" }}
          >
            Captain TC Mini Agent Rewards Wallet
          </h2>
          <h3
            style={{
              textAlign: "center",
              fontWeight: "normal",
              color: "#555",
              marginBottom: "20px",
            }}
          >
            ({miniWallet.title_name})
          </h3>

          <div className="reward-promo-table-wrap">
            <table className="reward-promo-table">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Card Serial Number</th>
                  <th style={{ textAlign: "center" }}>Cards Sold</th>
                  <th style={{ textAlign: "center" }}>TopCoin Rewards</th>
                  <th style={{ textAlign: "center" }}>Reward Payment</th>
                </tr>
              </thead>
              <tbody>
                {" "}
                {(() => {
                  const totalPages = miniWallet.sold_cards
                    ? Math.ceil(
                        miniWallet.sold_cards.length / miniWalletItemsPerPage,
                      )
                    : 0;
                  const paginatedCards = miniWallet.sold_cards
                    ? miniWallet.sold_cards.slice(
                        (miniWalletPage - 1) * miniWalletItemsPerPage,
                        miniWalletPage * miniWalletItemsPerPage,
                      )
                    : [];

                  if (paginatedCards.length > 0) {
                    return paginatedCards.map((card, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: "center" }}>{card.serial}</td>
                        <td style={{ textAlign: "center" }}>
                          {(miniWalletPage - 1) * miniWalletItemsPerPage +
                            index +
                            1}
                        </td>
                        <td style={{ textAlign: "center" }}>0 TopCoin</td>
                        <td style={{ textAlign: "center", fontWeight: "bold" }}>
                          £0.00
                        </td>
                      </tr>
                    ));
                  } else {
                    return (
                      <tr>
                        <td
                          colSpan="4"
                          style={{ textAlign: "center", padding: "15px" }}
                        >
                          No cards sold yet.
                        </td>
                      </tr>
                    );
                  }
                })()}
              </tbody>
            </table>
          </div>
          {miniWallet.sold_cards &&
            Math.ceil(miniWallet.sold_cards.length / miniWalletItemsPerPage) >
              1 && (
              <div
                className="pagination-container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "15px",
                  gap: "10px",
                  flexDirection: "row",
                }}
              >
                <button
                  disabled={miniWalletPage === 1}
                  onClick={() => setMiniWalletPage(miniWalletPage - 1)}
                  className="pagination-btn"
                  style={{
                    padding: "6px 12px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    background: miniWalletPage === 1 ? "#eee" : "#fff",
                    cursor: miniWalletPage === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  Prev
                </button>
                <span
                  style={{
                    alignSelf: "center",
                    fontSize: "14px",
                    color: "#555",
                  }}
                >
                  Page {miniWalletPage} of{" "}
                  {Math.ceil(
                    miniWallet.sold_cards.length / miniWalletItemsPerPage,
                  )}
                </span>
                <button
                  disabled={
                    miniWalletPage ===
                    Math.ceil(
                      miniWallet.sold_cards.length / miniWalletItemsPerPage,
                    )
                  }
                  onClick={() => setMiniWalletPage(miniWalletPage + 1)}
                  className="pagination-btn"
                  style={{
                    padding: "6px 12px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    background:
                      miniWalletPage ===
                      Math.ceil(
                        miniWallet.sold_cards.length / miniWalletItemsPerPage,
                      )
                        ? "#eee"
                        : "#fff",
                    cursor:
                      miniWalletPage ===
                      Math.ceil(
                        miniWallet.sold_cards.length / miniWalletItemsPerPage,
                      )
                        ? "not-allowed"
                        : "pointer",
                  }}
                >
                  Next
                </button>
              </div>
            )}
        </div>
      )}

      {!seniorWallet && !miniWallet && (
        <div
          style={{
            padding: "40px 20px",
            textAlign: "center",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            color: "#555",
          }}
        >
          <h3 style={{ marginBottom: "10px", color: "#333" }}>
            No Agent Card Assigned
          </h3>
          <p style={{ fontSize: "16px" }}>
            You do not currently have any Senior or Mini Agent cards assigned to your account.
          </p>
        </div>
      )}

    </div>
  );
}

export default CaptainTCCardAgent;
